import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import '../../../styles/flags.scss';

type languagesType = {
  key: string;
  label: string;
};

interface Props {
  langs: any[];
}

const languages = [
  {
    key: 'EN-US',
    label: 'English (US)',
  },
  {
    key: 'EN-GB',
    label: 'English (UK)',
  },
  {
    key: 'DE-DE',
    label: 'Deutsch',
  },
  {
    key: 'ES-ES',
    label: 'Español(ES)',
  },
  {
    key: 'ES-MX',
    label: 'Español(MX)',
  },
  {
    key: 'ES-AR',
    label: 'Español(AR)',
  },
  {
    key: 'FR-FR',
    label: 'Français',
  },
  {
    key: 'IT-IT',
    label: 'Italiano',
  },
  {
    key: 'PT-PT',
    label: 'Português (PT)',
  },
  {
    key: 'RU-RU',
    label: 'Русский',
  },
  {
    key: 'JA-JP',
    label: '日本語',
  },
  {
    key: 'ZH-CN',
    label: '简体中文',
  },
  {
    key: 'KO-KR',
    label: '한국어',
  },
  {
    key: 'TR-TR',
    label: 'Türkçe',
  },
  {
    key: 'AR-AE',
    label: 'المملكة العربية السعودية - العربية',
  },
  {
    key: 'IW-IL',
    label: 'עברית',
  },
  {
    key: 'PT-BR',
    label: 'Português(BR)',
  },
  {
    key: 'NL-NL',
    label: 'Nederlands',
  },
  {
    key: 'ZH-TW',
    label: '繁體中文',
  },
  {
    key: 'PL-PL',
    label: 'Polski',
  },
  {
    key: 'ID-ID',
    label: 'Bahasa Indonesia',
  },
  {
    key: 'TH-TH',
    label: 'ภาษาไทย',
  },
];

const { Option } = Select;

const FlagsComponent = ({ langs }: Props) => {
  const [lang, setLang] = useState<string>('English (US)');
  const [langData, setLangData] = useState<languagesType[]>([]);
  const [open, setOpen] = useState<boolean>(false);

  const setLanguage = (key: string): void => {
    const [keyValue] = languages.filter((c: languagesType) => c.label === key);
    if (keyValue) window.sessionStorage.setItem('langId', keyValue.key);
    return window.location.reload();
  };

  useEffect(() => {
    const langId = window.sessionStorage.getItem('langId');
    const [keyValue] = languages.filter((c: languagesType) => c.key === langId);
    if (keyValue) setLang(keyValue.label);
  }, []);

  useEffect(() => {
    const tempLang: any = [];
    langs.map((langKey: string) => {
      const [keyValue] = languages.filter(
        (c: languagesType) => c.key === langKey
      );
      if (keyValue) return tempLang.push(keyValue);
      return null;
    });
    setLangData(tempLang);
  }, [langs]);

  return (
    <div style={{ marginRight: 20 }}>
      <Select allowClear className="language-selector"
        showSearch
        value={lang}
        style={{ width: 180, padding: '6px 8px 7px 8px;' }}
        onChange={setLanguage}
        onClick={() => setOpen(!open)}
        suffixIcon={
          <DownOutlined
            style={{ color: '#fff' }}
            onClick={() => setOpen(!open)}
          />
        }
        open={open}
      >
        {langData
          .sort((a: languagesType, b: languagesType) => {
            if (a.label < b.label) {
              return -1;
            }
            if (a.label > b.label) {
              return 1;
            }
            return 0;
          })
          .map((c: languagesType, i: number) => (
            <Option
              key={c.key}
              value={c.label}
            >
              {c.label}
            </Option>
          ))}
      </Select>
    </div>
  );
};

export default FlagsComponent;
